export default __webpack_public_path__ + "assets/_Chapters/EPLSystem/br_er_er_ls.webp";